export default () => {

    $( document ).ready(function() {
        const ig = document.querySelector("#dklab_instagram_widget")

        if (ig) {
            const igText = ig.querySelector("#dklab_instagram_widget_heading a");

            if (igText) {
                igText.innerText = "Zobrazit profil Truefitt & Hill Czech Republic";
                igText.insertAdjacentHTML("beforebegin", `<div class = "title">Sledujte náš Instagram<div`)

            }

            const usp = document.querySelector("#footer .usp");

            if (usp) {
                ig.insertAdjacentElement("afterend", usp)
            }
        }
    });

}